/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SaveDealAsDraft200ResponseJournalEntriesInner
 */
export interface SaveDealAsDraft200ResponseJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'invalidTaxCodeCause': SaveDealAsDraft200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'description': string | null;
}

export const SaveDealAsDraft200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type SaveDealAsDraft200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof SaveDealAsDraft200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof SaveDealAsDraft200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum];


